const wishlistCounter = document.querySelector(".wishlist-counter");

  // Initialize active classes on page load
  function initWishlist() {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (wishlistCounter) {
      wishlistCounter.textContent = wishlist.length;
    }

    wishlist.forEach(handle => {
      document.querySelectorAll(`.wishlist[data-handle="${handle}"]`).forEach(el => {
        el.classList.add("active-wishlist");
        el.classList.remove("wishlist-custom-action");
      });
    });
  }

  // Add/remove wishlist item
  document.addEventListener("click", function(e) {
    // Add to wishlist
    const addBtn = e.target.closest(".wishlist-custom-action");
    if (addBtn) {
      e.preventDefault();
      const handle = addBtn.getAttribute("data-handle");
      let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

      if (!wishlist.includes(handle)) {
        wishlist.push(handle);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
      }

      document.querySelectorAll(`.wishlist[data-handle='${handle}']`).forEach(el => {
        el.classList.add("active-wishlist");
        el.classList.remove("wishlist-custom-action");
      });

      if (wishlistCounter) {
        wishlistCounter.textContent = wishlist.length;
      }
      return;
    }

    // Remove from wishlist
    const removeBtn = e.target.closest(".active-wishlist");
    if (removeBtn) {
      e.preventDefault();
      const handle = removeBtn.getAttribute("data-handle");
      let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

      const index = wishlist.indexOf(handle);
      if (index > -1) {
        wishlist.splice(index, 1);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
      }

      document.querySelectorAll(`.wishlist[data-handle='${handle}']`).forEach(el => {
        el.classList.remove("active-wishlist");
        el.classList.add("wishlist-custom-action");
      });

      if (wishlistCounter) {
        wishlistCounter.textContent = wishlist.length;
      }
    }
  });

  // Initialize on page load
  window.addEventListener("DOMContentLoaded", initWishlist);